import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createLink } from '../lib/api';

export default function NewLink() {
  const nav = useNavigate();
  const [url, setUrl] = useState('https://example.com');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const link = await createLink({
        type: 'website',
        payload: { url },
        destination: url,
      });
      nav(`/links/${link.id}`);
    } catch (err) {
      setError((err as Error).message);
      setBusy(false);
    }
  }

  return (
    <div className="max-w-xl">
      <button onClick={() => nav('/')} className="text-sm text-gray-500 hover:text-gray-900 mb-6">
        ← Back
      </button>
      <h1 className="text-2xl font-semibold mb-6">New link</h1>
      <form onSubmit={submit} className="bg-white rounded-xl border border-gray-200 p-6 space-y-4">
        <div>
          <label className="block text-sm font-medium mb-1">Destination URL</label>
          <input
            type="url"
            required
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            className="w-full border border-gray-300 rounded-lg px-3 py-2 font-mono text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
            placeholder="https://example.com"
          />
          <p className="text-xs text-gray-500 mt-1">
            Where the QR will redirect. You can change this any time after creation.
          </p>
        </div>
        {error && <p className="text-sm text-red-600">{error}</p>}
        <button
          type="submit"
          disabled={busy}
          className="bg-blue-600 text-white text-sm rounded-lg px-4 py-2 hover:bg-blue-700 disabled:opacity-50"
        >
          {busy ? 'Creating…' : 'Create link'}
        </button>
      </form>
    </div>
  );
}
